import React, { useState } from 'react';
import {createACl,deleteACl} from '../../../Services/rolesServices'
const Checkbox = ({ isSelected,roleId,permissionId }) => {
    const [isChecked, setChecked] = useState(isSelected); 
    const handleCheckboxChange = async (event) => {
      let params={role_id :roleId,permission_id:permissionId}
      if(event.target.checked){
        await createACl(params);
      }else{
        await deleteACl(params);
      } 
      setChecked(!isChecked);
    };
  
    return (
      <div>
        <input 
        onChange={handleCheckboxChange}
        className="form-check-input permissionselect" 
        checked={isChecked}
        type="checkbox"
        />
         
      </div>
    );
  };
  export default Checkbox;